import { NavLink, useHistory } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { getType } from "../helpers/authentication";

function Header() {
  const history = useHistory();
  const logout = () => {
    localStorage.clear();
    history.push("/admin/login");
  };
  const userType = getType();
  return (
    <Navbar expand="lg" sticky="top" color="light" bg="light">
      <Container fluid>
        <NavLink to="/admin" className="navbar-brand">
          <Image src="/Honda-logo.png" alt="logo" width={200} />
        </NavLink>
        {userType === "SuperAdmin" && (
          <Navbar.Collapse>
            <Nav>
              <NavItem>
                <NavLink to="/admin" className="nav-link">
                  Cameras
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/superadmin" className="nav-link">
                  Dealerships
                </NavLink>
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        )}
        <Button
          variant="link"
          size="sm"
          onClick={() => logout()}
          className="my-2"
        >
          <i className="fas fa-sign-out-alt"></i> Logout
        </Button>
      </Container>
    </Navbar>
  );
}

export default Header;
